import Headspace from 'headspace';

(function ($) {
    /* Custom JS
	   Feel free to break into separate files if individual functions grow to excessive sizes.
	   Gulp will concatenate and minify separate files automatically.
	*/

    //--- Search bar in Header Slides out on Magnifying Glass Click
    if ($(window).width() > 991) {
        const $searchInput = $('#header .search-form .form-control');
        const $searchButton = $('#header .search-form button');

        $searchButton.on('click', function (e) {
            if (!$searchInput.val()) {
                e.preventDefault();
                $searchInput.toggleClass('visible');
            } else {
                return true;
            }
        });
    }

    //--- Slick Slider
    $('.single-slider').slick({
        infinite: true,
        prevArrow: '<div class="slick-prev" aria-label="Previous Slide"><i class="fal fa-angle-left"></i></div>',
        nextArrow: '<div class="slick-next" aria-label="Next Slide"><i class="fal fa-angle-right"></i></div>',
    });

    $('.hero-slider').slick({
        infinite: true,
        dots: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 8000,
    });

    //--- Homepage Next Section Arrow in Hero
    // $('#nextSection').on('click', function () {
    //     fullpage_api.moveSectionDown();
    // });

    //--- Headspace
    Headspace(document.getElementById('header'), {
        tolerance: 8, // default: 8
        showAtBottom: true,
    });
})(jQuery);



// WEBPACK FOOTER //
// ./src/js/scripts.js